module.exports = __webpack_public_path__ + "static/58-6ffff9d33772fb2c6f6c9f11ce923355.png";